import React from 'react';

import { MtxButton, MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import PartnerGrid from '@/components/PartnerGrid/PartnerGrid';
import { URLS } from '@/constants/urls';
import { useAuth } from '@/hooks/useAuth';

import styles from './styles.module.css';

export const ErrorPage: React.FC = () => {
  const { user } = useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  let text1 = '';
  let text2 = '';

  if (user) {
    text1 = t('errorPage.loadingErrorMessage');
    text2 = t('errorPage.retryLaterMessage');
  } else {
    text1 = t('errorPage.serviceIncidentMessage');
    text2 = t('errorPage.apologiesMessage');
  }

  return (
    <div className={`${styles.errorPage} ${user ? styles.errorPagePadding : ''}`}>
      <MtxGrid row>
        <MtxGrid
          className={styles.errorPageHeader}
          col={6}
          colXl={6}
          colLg={6}
          colMd={6}
          colSm={8}
          colXs={12}
          offset={3}
          offsetXl={3}
          offsetLg={3}
          offsetMd={3}
          offsetSm={2}
          offsetXs={0}
        >
          <i className={'totem-icon totem-icon-warning-solide ' + styles.iconError} />
          <div className={styles.errorPageTitle}>
            <h2>{t('errorPage.title')}</h2>
            <p>{text1}</p>
            <p>{text2}</p>
          </div>

          {user ? (
            <MtxButton
              fullWidth
              size="large"
              onClick={() => {
                if (state === null) {
                  globalThis.history.back();
                } else {
                  navigate(state.goTo);
                }
              }}
            >
              <div>{t('common.return')}</div>
            </MtxButton>
          ) : (
            <MtxButton
              fullWidth
              size="large"
              onClick={() => {
                globalThis.location.href = URLS.MTP_URL;
              }}
            >
              <div>{t('errorPage.buttonText')}</div>
            </MtxButton>
          )}
        </MtxGrid>
      </MtxGrid>

      <MtxGrid row>
        <MtxGrid col={12} colXl={12} colLg={12} colMd={12} colSm={12} colXs={12}>
          <h3 className={styles.errorPageSubtitle}>{t('partnerInfo.title')}</h3>
        </MtxGrid>
      </MtxGrid>

      <PartnerGrid />
    </div>
  );
};
